import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import LogoV from "../../assets/LogoV.png"
import { toast } from "react-toastify";


const AdminLoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (username === "Admin" && password === "12345") {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.setItem("isAdmin", "true");
  
      toast.success("Login successful!");
  
      setTimeout(() => {
        navigate("/dashboard");
        window.location.reload();
      }, 1000); // slight delay to let toast show before navigation
    } else {
      setError("Invalid admin credentials");
      toast.error("Invalid admin credentials");
    }
  };
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-md w-full max-w-md mx-4"
      >
<div className="flex items-center justify-center space-x-4 mb-4">
  <img src={LogoV} alt="Logo" className="h-20 w-20 object-contain" />
  <h1 className="text-3xl font-bold text-gray-800">Login</h1>
</div>
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        )}

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter admin username"
            className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter admin password"
            className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-md transition duration-200"
        >
          Login
        </button>
        <p className="text-center mt-4 text-gray-600 text-sm">
  Developed © 2025 by{" "}
  <Link
    to="https://oakyaitservices.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-500 hover:underline"
  >
    Oakya IT Services
  </Link>
</p>

      </form>


    </div>




  );
};

export default AdminLoginForm;